<div fxLayout>
  <sbnb-subnav fxFlex="280px" fxHide.lt-md header="Apps">
    <sbnb-apps-subnav></sbnb-apps-subnav>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <sbnb-helptext-wrapper class="block mb-10" [area]="'intro'" [pageId]="'apps'"></sbnb-helptext-wrapper>

    <!-- Integrations -->
    <div fxLayout="column" fxLayoutGap="16px" style="margin-bottom: 24px">
      <app-feature-flag-tabs>
        <sbnb-page-header navTabs [parentPath]="'menu-mobile'">
          <h2 class="integrations-header">Integrations</h2>
        </sbnb-page-header>
        <h2 class="integrations-header">Integrations</h2>
      </app-feature-flag-tabs>

      <div
        fxLayout
        fxLayout.lt-md="column"
        fxLayoutAlign.lt-md="start start"
        fxLayoutGap.lt-md="8px"
        fxLayoutGap="12px"
        fxLayoutAlign="space-between center">
        <div fxLayout fxLayoutGap="4px" class="app-filter">
          <button
            class="filter-btn"
            fxLayoutAlign="start center"
            fxLayoutGap="6px"
            [matMenuTriggerFor]="categoriesMenu">
            <sbnb-icon [size]="16" icon="tag" class="shrink-0 text-night-lighter"></sbnb-icon>
            <span class="ellipsis">Category: {{ categories | async | categoriesFilterLabel }}</span>
          </button>

          <mat-menu #categoriesMenu="matMenu" class="apps-filter-menu">
            <div *ngFor="let intCategory of integrationsCategories$ | async">
              <mat-checkbox
                fxFlex
                class="text__small"
                [checked]="(categories | async)?.includes(intCategory)"
                (change)="handleCategoryChange($event, intCategory)"
                (click)="preventClose($event)">
                {{ intCategory }}
              </mat-checkbox>
            </div>
          </mat-menu>

          <button class="filter-btn" fxLayoutAlign="start center" fxLayoutGap="6px" [matMenuTriggerFor]="builtByMenu">
            <sbnb-icon [size]="16" icon="handshake-circle" class="text-night-lighter"></sbnb-icon>
            <span class="ellipsis">Built by: {{ builtBy | async | builtByLabel }}</span>
          </button>

          <mat-menu #builtByMenu="matMenu" class="apps-filter-menu">
            <button mat-menu-item (click)="builtBy.next('hospitable')">Hospitable</button>
            <button mat-menu-item (click)="builtBy.next('partner')">Hospitable partners</button>
          </mat-menu>

          <sbnb-button
            *ngIf="(categories | async)?.length || (builtBy | async)"
            type="text"
            size="mini"
            (click)="categories.next([]); builtBy.next(null)">
            Clear
          </sbnb-button>
        </div>

        <sbnb-search-bar
          fxFlex.lt-md
          style="height: 32px; width: 320px"
          placeholderText="Search integrations..."
          (searchChanged)="searchCriteria.next($event)"></sbnb-search-bar>
      </div>
    </div>

    <div *ngIf="integrations$ | async as integrations" class="grid grid-cols-1 sbnbDesktop:grid-cols-2 gap-6">
      <sbnb-apps-overview-item *ngFor="let integration of integrations" [app]="integration"></sbnb-apps-overview-item>
    </div>

    <!-- Tools -->
    <ng-container *ngIf="tools$ | async as tools">
      <h2 class="apps__spacer">Tools</h2>

      <div class="grid grid-cols-1 sbnbDesktop:grid-cols-2 gap-6">
        <sbnb-apps-overview-item *ngFor="let tool of tools" [app]="tool"></sbnb-apps-overview-item>
      </div>
    </ng-container>
  </main>
</div>

<app-feature-flag-tabs style="position: unset !important">
  <sbnb-mobile-sidebar [title]="'Apps'" [top]="64" navTabs>
    <sbnb-apps-subnav></sbnb-apps-subnav>
  </sbnb-mobile-sidebar>
  <sbnb-mobile-sidebar [title]="'Apps'">
    <sbnb-apps-subnav></sbnb-apps-subnav>
  </sbnb-mobile-sidebar>
</app-feature-flag-tabs>
